import React from 'react'
import { Tag } from '@pankod/refine-antd'

import { kapabilitasMapper } from '@components/DataTableParticipants/blocks/utils'

export const renderFallback = (value?: React.ReactNode) => value ?? '-'

export const formatTextValue = (value?: string | null) => {
  if (!value || !value.trim()) return '-'

  return value
}

export const formatNumberValue = (value?: number | null, suffix?: string) => {
  if (typeof value !== 'number' || Number.isNaN(value)) return '-'

  return suffix ? `${value} ${suffix}` : String(value)
}

export const renderCertificateTypeTag = (
  value?: 'completion' | 'participation' | null,
) => {
  if (value === 'completion') {
    return <Tag color="cyan">Penyelesaian</Tag>
  }

  if (value === 'participation') {
    return <Tag color="volcano">Partisipasi</Tag>
  }

  return '-'
}

export const formatCapabilityLabel = (value?: string | null) => {
  if (!value) return '-'

  return kapabilitasMapper(value)
}
